export const Gap = () => <div style={{ marginTop: '20px' }} />;
